export default __webpack_public_path__ + "static/media/coins-blue.d302637e.svg";